import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAc911jf9k0-c5X5j5_tLlO8PZBSdm9YjM",
  authDomain: "nkanyezi-safepickup.firebaseapp.com",
  projectId: "nkanyezi-safepickup",
  storageBucket: "nkanyezi-safepickup.firebasestorage.app",
  messagingSenderId: "452616810457",
  appId: "1:452616810457:web:57a9494c4aa5112b51b3c8",
  measurementId: "G-ZW1K1BHWGT"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);
export default app;
